<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add / Remove Courses
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar dark color="secondary">
      <v-chip color text-color="white" @click="e1 = 1">
        <v-avatar>
          <!--<v-icon>account_circle</v-icon>-->
        </v-avatar>
        {{ selectedTotal }} Selected Courses
      </v-chip>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            :loading="loading"
            :items="courses"
            show-select
            item-key="id"
          >
            <template v-slot:item.name="{ item }">
              <table-thumb :thumb="item"></table-thumb>
              <span class="ml-2">{{item.name}}</span>
            </template>
            <template v-slot:item.published="{ item }">
              <v-icon v-if="item.published" color="green">fa-check</v-icon>
              <v-icon v-else color="red">fa-times</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="100">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="primary" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2" @click="saveModules">Save Courses</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import TableThumb from "@/components/admin/course/TableThumb";

export default {
  name: "ChannelModules",
  components: {
    TableThumb
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "name" },
        {
          text: "Published",
          value: "published",
          sortable: false,
          align: "center"
        }
      ],
      courses: [],
      search: "",
      pagination: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      channel: [],
      modules: {},
      topics: [],
      search: "",
      loading: false,
      successMessage: "Playlist Courses Saved",
      errorMessage:
        "Oops, something went wrong! Please check information is correct."
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    }
  },
  mounted() {
    this.getCourses();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    saveModules() {},
    getCourses() {
      // getCoursesData: this table reads id/name/published/thumbnail only -
      // all carried by the light endpoint. Params kept as-is ("" = first
      // default page, the existing behaviour of this screen).
      courseAPI.getCoursesData("").then(response => {
        this.courses = response.data.data;
      });
    }
  }
};
</script>
